import 'bootstrap/js/dist/modal';

export const makeFormData = (parent) => {
    const data = {};

    parent.find('input[name]').each(function () {
        const name = $(this).attr('name');

        data[name] = $(this).val();
    });

    parent.find('select[name]').each(function () {
        const name = $(this).attr('name');

        data[name] = $(this).val();
    });

    parent.find('input[name][type="checkbox"]').each(function () {
        const name = $(this).attr('name');

        data[name] = $(this).is(':checked');
    });

    return data;
};

export const makeAuthFormData = (parent, token) => {
    const data = makeFormData(parent);
    data.reCaptcha = token;

    return data;
};
